import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: none;
  }
`;

export const ProgressBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  animation: ${fadeIn} 0.35s ease;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const MessageTitle = styled.strong`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const MessageText = styled.span`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;

export const Track = styled.div`
  height: 8px;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.porterBlue50};
`;

export const Fill = styled.span.attrs(({ $percent }) => ({
  style: { width: `${Math.round($percent)}%` },
}))`
  display: block;
  height: 100%;
  border-radius: inherit;
  background-color: ${({ theme }) => theme.colors.porterBlue500};
  transition: width 0.6s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;

export const Dots = styled.div`
  display: flex;
  gap: 8px;
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme, $active }) =>
    $active
      ? theme.colors.porterBlue500
      : theme.colors.semantic.border.default};
  transition: background-color 0.3s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
